import { render, staticRenderFns } from "./ReAllocate.vue?vue&type=template&id=2c6a5476&scoped=true&"
import script from "./ReAllocate.vue?vue&type=script&lang=js&"
export * from "./ReAllocate.vue?vue&type=script&lang=js&"
import style0 from "./ReAllocate.vue?vue&type=style&index=0&id=2c6a5476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a5476",
  null
  
)

export default component.exports